<form [formGroup]="cloneForm">
  <div fxLayout="row" fxLayoutGap="30px">
    <mat-form-field appearance="outline" fxFlex="50" (click)="openSourceEventsDialog()">
      <mat-label>Source Event</mat-label>
      <input matInput readonly formControlName="sourceEvent" placeholder="Choose Source Event" />
      @if (cloneForm.controls['sourceEvent'].hasError('required')) {
        <mat-error>
          Source event is required
        </mat-error>
      }
    </mat-form-field>
    <mat-form-field appearance="outline" fxFlex="50" (click)="openDestinationEventsDialog()">
      <mat-label>Destination Event</mat-label>
      <input matInput readonly formControlName="destinationEvent" placeholder="Choose Destination Event" />
      @if (cloneForm.controls['destinationEvent'].hasError('required')) {
        <mat-error>
          Destination event is required
        </mat-error>
      }
    </mat-form-field>
  </div>
  <mat-card-actions fxLayout="row" fxLayoutAlign="end" class="actions-bar">
    <button mat-stroked-button type="button" (click)="closeDialog()" style="margin-right: 10px;">
      Cancel
    </button>
    <button mat-raised-button type="button" color="accent" [disabled]="cloneForm.invalid || sourceEventId === destinationEventId"
      (click)="cloneVersions()">
      Clone Versions/Stores
    </button>
  </mat-card-actions>
</form>
